import React, { Component, PropTypes } from 'react';
import { SparkTabs } from '../../../ui/spark';
import { connect } from 'react-redux';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import ThemeColorPanel from './ColorPanel';
import { MainColorPicker } from '../../../widgets/index';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { MESSAGE_COLOR, BACKGROUND_COLOR } from '../../../../constants/ActionTypes';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import { range } from 'lodash';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import { checkPermissionForLevel } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

const prefix = 'colors';

class ThemeColors extends Component {
    componentDidMount() {
        this.tabsElm = new SparkTabs(this.tabsNode);
    }

    render() {
        const borderRadius = new CSSLength(this.props.border.radius, {
            base: 16,
            formatter: (value, unit) => value + unit
        });

        return (
            <div className="ThemeColors Theme-Content">
                <h1>Colors</h1>
                <p className="normal-text">Select the colors that will be used as the basic colors for your theme.</p>
                <div className="subpages-main-content row">
                    <div ref={node => (this.tabsNode = node)} className="spark-tabs col-lg-12">
                        <nav className="spark-tabs__nav" role="menubar">
                            <div className="spark-tabs__scroll">
                                <ul className="spark-tabs__list" role="tablist">
                                    <li
                                        className="spark-tabs__tab active text-center"
                                        role="tab"
                                        aria-controls="colors-tab"
                                    >
                                        <a>Colors</a>
                                    </li>
                                    {/* <li className="spark-tabs__tab  text-center" role="tab"><a>Background Colors</a></li>*/}
                                    <li
                                        className="spark-tabs__tab  text-center"
                                        role="tab"
                                        aria-controls="messages-tab"
                                    >
                                        <a>Messages</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="spark-tabs__btns">
                                <button className="spark-tabs__btn spark-icon-arrow-chevron-left spark-tabs__btn--left" />
                                <button className="spark-tabs__btn spark-icon-arrow-chevron-right spark-tabs__btn--right" />
                            </div>
                        </nav>
                        <div className="spark-tabs__panels">
                            <div role="tabpanel" className="spark-tabs__panel" id="colors-tab">
                                <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                                    <ThemeColorPanel
                                        id="primary-colors"
                                        panel="primary"
                                        colors={this.props.primary.colors}
                                        onColorChange={this.props.onColorChange}
                                        isDisabled={!this.props.hasAccessEdit}
                                        headline="Color Palette"
                                        subheader="Select a primary color palette that will be used throughout your theme."
                                        messageType={[]}
                                    />
                                </div>
                                <div
                                    className="col-xs-12"
                                    style={{
                                        marginTop: '25px'
                                    }}
                                >
                                    <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                                        <h4>Background</h4>
                                        <p className="normal-text">Select the background colors for the application</p>
                                        <div className="row">
                                            <div className="ThemeColorRow col-sm-1">
                                                Body
                                                <BackgroundPicker
                                                    background={this.props.background.body}
                                                    preset={this.props.primary.colors}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onChange={property =>
                                                        this.props.onBackgroundColorChange('body')({
                                                            target: {
                                                                value: property
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="ThemeColorRow col-sm-1">
                                                Style1
                                                <BackgroundPicker
                                                    background={this.props.background.style1}
                                                    preset={this.props.primary.colors}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onChange={property =>
                                                        this.props.onBackgroundColorChange('style1')({
                                                            target: {
                                                                value: property
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="ThemeColorRow col-sm-1">
                                                Style2
                                                <BackgroundPicker
                                                    background={this.props.background.style2}
                                                    preset={this.props.primary.colors}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onChange={property =>
                                                        this.props.onBackgroundColorChange('style2')({
                                                            target: {
                                                                value: property
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="ThemeColorRow col-sm-1">
                                                Style3
                                                <BackgroundPicker
                                                    background={this.props.background.style3}
                                                    preset={this.props.primary.colors}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onChange={property =>
                                                        this.props.onBackgroundColorChange('style3')({
                                                            target: {
                                                                value: property
                                                            }
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                                        <h4>Border</h4>
                                        <p className="normal-text">Select the border colors for the application</p>
                                        <div className="row">
                                            <div className="ThemeColorRow col-sm-1">
                                                <ReactSparkSelectInput
                                                    label="Radius"
                                                    values={range(20).map(v => ({ key: `${v}px`, label: `${v}px` }))}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onChange={this.props.onThemePropChange('border.radius')}
                                                    defaultValue={_.get(borderRadius, 'px', '0px')}
                                                />
                                            </div>
                                            <div className="ThemeColorRow col-sm-1">
                                                Style 1
                                                <MainColorPicker
                                                    color={this.props.border.color.style1}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onColorChange={this.props.onThemePropChange('border.color.style1')}
                                                />
                                            </div>
                                            <div className="ThemeColorRow col-sm-1">
                                                Style 2
                                                <MainColorPicker
                                                    color={this.props.border.color.style2}
                                                    isDisabled={!this.props.hasAccessEdit}
                                                    onColorChange={this.props.onThemePropChange('border.color.style2')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div role="tabpanel" className="spark-tabs__panel">
                <ThemeColorPanel
                  id="background-colors"
                  panel="background"
                  colors={this.props.background.colors}
                  onColorChange={this.props.onColorChange}
                  headline="Background Colors"
                  subheader="Select the main background colors."
                />
              </div> */}
                            <div role="tabpanel" className="spark-tabs__panel" id="messages-tab">
                                <ThemeColorPanel
                                    id="message-colors"
                                    panel="messages"
                                    colors={this.props.messages.colors}
                                    onColorChange={this.props.onColorChange}
                                    headline="Messages"
                                    subheader="Select colors used for system messages."
                                    messageType={['Error', 'Warning', 'Success', 'Info']}
                                />
                                <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                                    <div className="row">
                                        <div className="col-lg-3">
                                            <h4 className="margin-top-bottom col-lg-3">Success</h4>
                                            <div className="row col-lg-12">
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Color
                                                    <MainColorPicker
                                                        color={this.props.message.success.color}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onMessageColorChange('success')}
                                                    />
                                                </div>
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Icon Color
                                                    <MainColorPicker
                                                        color={this.props.message.success.icon}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onThemePropChange(
                                                            'message.success.icon'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <h4 className="margin-top-bottom col-lg-3">Warning</h4>
                                            <div className="row col-lg-12">
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Color
                                                    <MainColorPicker
                                                        color={this.props.message.warning.color}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onMessageColorChange('warning')}
                                                    />
                                                </div>
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Icon Color
                                                    <MainColorPicker
                                                        color={this.props.message.warning.icon}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onThemePropChange(
                                                            'message.warning.icon'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <h4 className="margin-top-bottom col-lg-3">Error</h4>
                                            <div className="row">
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Color
                                                    <MainColorPicker
                                                        color={this.props.message.error.color}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onMessageColorChange('error')}
                                                    />
                                                </div>
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Icon Color
                                                    <MainColorPicker
                                                        color={this.props.message.error.icon}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onThemePropChange(
                                                            'message.error.icon'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <h4 className="margin-top-bottom ">Info</h4>
                                            <div className="row">
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Color
                                                    <MainColorPicker
                                                        color={this.props.message.info.color}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onMessageColorChange('info')}
                                                    />
                                                </div>
                                                <div className="ThemeColorRow col-sm-1 col-lg-6">
                                                    Icon Color
                                                    <MainColorPicker
                                                        color={this.props.message.info.icon}
                                                        isDisabled={!this.props.hasAccessEdit}
                                                        onColorChange={this.props.onThemePropChange(
                                                            'message.info.icon'
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>
        );
    }
}

ThemeColors.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        ...state.app.data.theme.colors,
        ...state.theme.colors,
        message: state.app.data.theme.colors.message,
        background: state.app.data.theme.colors.background,
        border: state.app.data.theme.colors.border,
        colorLight: state.app.data.theme.global.font,
        hasAccessEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onColorChange: (idx, panel, label) => event => {
            let color = event.target.value;
            dispatch(ThemeActions.setPaletteColor(idx, panel, label, color));
        },
        onMessageColorChange: messageType => {
            return event => {
                dispatch({
                    type: MESSAGE_COLOR,
                    color: event.target.value,
                    messageType: messageType
                });
            };
        },
        onBackgroundColorChange: messageType => {
            return event => {
                dispatch({
                    type: BACKGROUND_COLOR,
                    color: event.target.value,
                    messageType: messageType
                });
            };
        },
        onThemePropChange: onThemePropChange(dispatch, prefix),
        onThemePropChange2: onThemePropChange(dispatch, 'global'),
        onBorderUpdate: (border, borderValue, type, index) => {
            const value = borderValue;
            return event => {
                value[index] = event.target.value;
                return dispatch(ThemeActions.modifyThemeKey(`${border}.${type}`, value.join(' ')));
            };
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeColors);



// WEBPACK FOOTER //
// ./src/components/pages/theme/colors/index.js